import { API } from "shared/services";

export function exportReport(start, end, reportType) {
  return API.get(
    `/customer_reports/${reportType}?start_at=${start}&end_at=${end}`,
    { responseType: "text/csv" }
  );
}
